import { StandaloneRootEssentials, } from './StandaloneRootEssentials';
export function createEssentials(options) {
    return new StandaloneRootEssentials(options);
}
//# sourceMappingURL=createEssentials.js.map